module.exports = __webpack_public_path__ + "static/media/Wilpattu.c5f0ebce.png";